export const UNDEFINED_SPACE_KEY = '__UNDEFINED_SPACE_KEY__';
